export default "__VITE_ASSET__C57Lrngu__"